import { useState, useEffect, useRef } from "react";
import { Link } from "@/components/common/Link";
const cards = [{
  title: "Generador de Nombres de Negocios.",
  body: "Genera un nombre de negocio único y listo para tu marca en segundos.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/business_name_img.png",
  alt: "Generador de Nombres de Negocios.",
  href: "#",
  sparkles: []
}, {
  title: "Generador de Eslóganes.",
  body: "Crea un eslogan pegadizo y memorable que se adapte a tu marca.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/slogan_generator_img.png",
  alt: "Generador de Eslóganes.",
  href: "#",
  sparkles: []
}, {
  title: "Creador de Logos con IA.",
  body: "Diseña un logo profesional sin esfuerzo con inteligencia artificial.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/logo_maker_img.jpg",
  alt: "Creador de Logos con IA.",
  href: "#",
  sparkles: [{
    top: "8px",
    left: "12px",
    size: 16
  }, {
    top: "50%",
    right: "12px",
    size: 12
  }]
}, {
  title: "Generador de Declaraciones de Misión.",
  body: "Genera una declaración de misión clara e impactante para tu negocio.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/mission.jpg",
  alt: "Generador de Declaraciones de Misión.",
  href: "#",
  sparkles: [{
    top: "8px",
    right: "16px",
    size: 14
  }]
}, {
  title: "Generador de Declaraciones de Visión.",
  body: "Crea una declaración de visión sólida que guíe tu marca hacia el éxito.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/vision.jpg",
  alt: "Generador de Declaraciones de Visión.",
  href: "#",
  sparkles: []
}];
function SparkleIcon({
  size
}: {
  size: number;
}) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2L13.5 10.5L22 12L13.5 13.5L12 22L10.5 13.5L2 12L10.5 10.5L12 2Z" />
    </svg>;
}
export default function MoreToolsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const carouselRef = useRef<HTMLDivElement>(null);
  const sectionRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);
  const handlePrev = () => {
    setCurrentIndex(prev => Math.max(0, prev - 1));
  };
  const handleNext = () => {
    setCurrentIndex(prev => Math.min(cards.length - 1, prev + 1));
  };
  const cardWidth = 340;
  const cardGap = 24;
  return <section ref={sectionRef} className={`transition-all duration-700 ease-out ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
    backgroundColor: "#ffffff",
    color: "rgb(20, 21, 31)",
    fontFamily: '"Evergrow Sans", Inter, sans-serif',
    overflow: "hidden",
    margin: "152px 0px"
  }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
        .tool-card {
          background-color: #F5F5F6;
          border-radius: 12px;
          overflow: hidden;
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }
        .tool-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 32px rgba(0,0,0,0.10);
        }
        .tool-card-link {
          text-decoration: none;
          color: rgb(0,0,0);
          transition: opacity 0.15s;
        }
        .tool-card-link:hover {
          opacity: 0.75;
        }
        .slick-arrow-btn {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          border: none;
          background-color: rgb(245, 245, 246);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: background-color 0.2s ease, transform 0.2s ease;
          flex-shrink: 0;
        }
        .slick-arrow-btn:hover {
          background-color: rgb(225, 225, 230);
          transform: scale(1.05);
        }
        .slick-arrow-btn:disabled {
          opacity: 0.4;
          cursor: default;
        }
        .carousel-track {
          display: flex;
          gap: 24px;
          transition: transform 0.4s cubic-bezier(0.12, 0.23, 0.5, 1);
        }
        .section-fade {
          transition: opacity 0.5s cubic-bezier(0.12, 0.23, 0.5, 1), transform 0.5s cubic-bezier(0.12, 0.23, 0.5, 1);
        }
      `}</style>

      <div className="page-container">
        <div className={`section-fade ${visible ? "opacity-100" : "opacity-0"}`} style={{
        transform: visible ? "translateY(0)" : "translateY(30px)"
      }}>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 md:gap-8" style={{
          marginBottom: "40px"
        }}>
            <div style={{
            maxWidth: "600px"
          }}>
              <h2 style={{
              color: "rgb(20, 21, 31)",
              fontFamily: '"Evergrow Sans", Inter, sans-serif',
              fontSize: "40px",
              fontWeight: "700",
              lineHeight: "52px",
              border: "0px none rgb(20, 21, 31)",
              margin: "0 0 12px 0"
            }} className="!font-medium">
                Más herramientas para el éxito de tu negocio.
              </h2>
              <p style={{
              fontFamily: '"Evergrow Sans", Inter, sans-serif',
              fontSize: "16px",
              fontWeight: "400",
              lineHeight: "24px",
              color: "rgb(20, 21, 31)",
              opacity: 0.7,
              margin: 0
            }}>
                Explora más herramientas de IA para lanzar y hacer crecer tu negocio en línea.
              </p>
            </div>

            <div className="flex flex-row gap-3 flex-shrink-0">
              <button className="slick-arrow-btn" onClick={handlePrev} disabled={currentIndex === 0} aria-label="Previous" style={{
              color: "rgb(20, 21, 31)",
              fontFamily: '"Evergrow Sans", Inter, sans-serif',
              fontWeight: "400",
              backgroundColor: "rgb(245, 245, 246)",
              borderRadius: "50%",
              border: "0px none rgb(20, 21, 31)",
              padding: "1px 6px",
              textAlign: "center"
            }}>
                <img src="https://10web.io/wp-content/uploads/tenweb-theme/images/icons/arrows/arrow-grey.svg" alt="Previous" style={{
                width: "24px",
                height: "24px",
                opacity: 0.5,
                transform: "rotateZ(180deg)",
                display: "block"
              }} />
              </button>
              <button className="slick-arrow-btn" onClick={handleNext} disabled={currentIndex >= cards.length - 1} aria-label="Next" style={{
              color: "rgb(20, 21, 31)",
              fontFamily: '"Evergrow Sans", Inter, sans-serif',
              fontWeight: "400",
              backgroundColor: "rgb(245, 245, 246)",
              borderRadius: "50%",
              border: "0px none rgb(20, 21, 31)",
              padding: "1px 6px",
              textAlign: "center"
            }}>
                <img src="https://10web.io/wp-content/uploads/tenweb-theme/images/icons/arrows/arrow-grey.svg" alt="Next" style={{
                width: "24px",
                height: "24px",
                opacity: 0.5,
                display: "block"
              }} />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div style={{
      overflow: "hidden",
      paddingLeft: "max(24px, calc((100% - 1280px) / 2))"
    }}>
        <div ref={carouselRef} className="carousel-track" style={{
        transform: `translateX(calc(-${currentIndex} * (${cardWidth}px + ${cardGap}px)))`,
        paddingRight: "24px"
      }}>
          {cards.map((card, i) => <div key={i} data-index={i} className="tool-card" style={{
          width: `${cardWidth}px`,
          minHeight: "520px"
        }}>
              <div style={{
            padding: "28px 28px 20px 28px",
            flexShrink: 0
          }}>
                <Link to={card.href} className="tool-card-link" style={{
              color: "rgb(0, 0, 0)",
              fontFamily: '"Evergrow Sans", Inter, sans-serif',
              fontSize: "28px",
              fontWeight: "700",
              lineHeight: "40px",
              border: "0px none rgb(0, 0, 0)",
              display: "block",
              marginBottom: "12px"
            }}>
                  {card.title}
                </Link>
                <p style={{
              fontFamily: '"Evergrow Sans", Inter, sans-serif',
              fontSize: "15px",
              fontWeight: "400",
              lineHeight: "24px",
              color: "rgb(20, 21, 31)",
              opacity: 0.7,
              margin: 0
            }}>
                  {card.body}
                </p>
              </div>

              <div style={{
            position: "relative",
            flex: 1,
            minHeight: "240px",
            overflow: "hidden",
            borderRadius: "0 0 12px 12px"
          }}>
                {card.sparkles.map((sp, si) => <div key={si} style={{
              position: "absolute",
              top: (sp as any).top,
              left: (sp as any).left,
              right: (sp as any).right,
              zIndex: 2
            }}>
                    <SparkleIcon size={sp.size} />
                  </div>)}
                <img src={card.image} data-wvc-srcset={`${card.image}-wvc-srcset`} data-wvc-sizes={`${card.image}-wvc-sizes`} alt={card.alt} className="w-full h-auto" style={{
              display: "block",
              objectFit: "cover",
              width: "100%",
              height: "100%",
              borderRadius: "0 0 12px 12px"
            }} loading="lazy" />
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}